import type { App } from 'vue'
import { router } from '@inertiajs/vue3'

let cachedTranslations: Record<string, string> = {}

function lookup(key: string, replacements: Record<string, string | number> = {}): string {
    let value = cachedTranslations[key] ?? key
    for (const [k, v] of Object.entries(replacements)) {
        value = value.replace(`:${k}`, String(v))
    }
    return value
}

export function installTranslate(app: App, initialProps: Record<string, unknown>) {
    cachedTranslations = (initialProps.translations as Record<string, string>) ?? {}
    router.on('navigate', (event) => {
        const t = (event.detail.page.props as { translations?: Record<string, string> }).translations
        if (t) cachedTranslations = t
    })
    app.config.globalProperties.$t = lookup
}

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $t: (key: string, replacements?: Record<string, string | number>) => string
    }
}
